import React from "react";

//Styles
import {
  Container,
  Content,
  StepperContainer,
  Stepper,
  TimeLineContiner,
  FileContainer,
  Upload,
  File,
  UploadContainer,
  TitleFile,
  DownLoad,
} from "./style";
//Component
import Header from "@components/Header";
import Jumbotron from "./JumBotron";
import Timeline from "@components/TimeLine";
import { useLocation } from "react-router-dom";
import NotFound from "@pages/NotFound";

const ViewPQRS = () => {
  const location = useLocation();
  if (!location.state) {
    return <NotFound />;
  }
  const currentStep = location.state.process.length - 1;
  const isRejected = location.state.isRejected;
  const name = location.state.name;
  const serial = location.state.serial;
  const remaining = location.state.remaining;
  const files = location.state.files?.filter(({ path }: any) =>
    path.includes("doctor")
  );
  const STEPS = !isRejected
    ? ["Ingresado", "Tramite", "Cerrado"]
    : ["Ingresado", "Cerrado"];
  return (
    <Container>
      <Header />
      <Jumbotron
        isRejected={isRejected}
        serial={serial}
        state={currentStep}
        name={name}
        remaining={remaining}
      />
      <Content>
        <StepperContainer>
          <Stepper
            steps={STEPS}
            currentStep={currentStep}
            isRejected={isRejected}
          />
        </StepperContainer>
        <TimeLineContiner>
          <Timeline logs={location.state} />
        </TimeLineContiner>
        {!!files?.length && <TitleFile>Archivos Adjuntos</TitleFile>}
        <UploadContainer>
          {files?.map((file: any, idx: number) => {
            return (
              <DownLoad key={idx} href={`${file.path}`} target={"blank"}>
                Descargar Documento
              </DownLoad>
            );
          })}
        </UploadContainer>
      </Content>
    </Container>
  );
};

export default ViewPQRS;
